// Math-Helper für deterministische Rendering-Primitives.
// Phase 11 Step 3 — Screenshot-Stabilität für DecDots & Co.

/**
 * Simpler, deterministischer Pseudo-Zufall aus einem Integer-Seed.
 * Mulberry32 — 32-bit State, guter Streuungsqualität für Decoration-Muster,
 * kein externes Package nötig. Gibt einen Float in [0, 1).
 *
 * Wichtig: **nicht** für Security verwenden — rein für visuelle Pattern.
 */
export function seededRandom(seed: number): number {
  let t = (seed + 0x6d2b79f5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
